import { FC } from 'react';

import { GenAiLoadingAnimation } from 'modules/ai/ui/animations/GenAiLoadingAnimation';
import {
  NBACreationLoadingContainer,
  LoadingTextContainer,
  LoadingText,
} from 'modules/ai/nba/components/NBACreationLoading.styles';

export const nbaReengageCreateLoadingModalIds = {
  nbaCreateLoadingModal: 'nba-create-loading-modal',
};
export const NBACreationLoading: FC = () => {
  return (
    <NBACreationLoadingContainer data-test={nbaReengageCreateLoadingModalIds.nbaCreateLoadingModal}>
      <GenAiLoadingAnimation width={104} />
      <LoadingTextContainer>
        <LoadingText>Creating new list...</LoadingText>
        <LoadingText>Cloning campaign...</LoadingText>
        <LoadingText>Applying selected copy...</LoadingText>
      </LoadingTextContainer>
    </NBACreationLoadingContainer>
  );
};
